module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00061-fs8.4566273.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00061-fs8.png
// module id = 214
// module chunks = 0